import { createDirectus, graphql, staticToken } from '@directus/sdk';

const CMS_URL = process.env.CMS_URL;

export interface ShowroomTopics {
  id: string;
  parent_topic: string;
  video_app_scene: string;
  translations: {
    language: string;
    title: string;
  }[];
  slug: string;

  topics?: ShowroomTopics[];
}

interface GraphqlResult {
  video_app_topics: {
    id: string;
    slug: string;
    parent_topic: { id: string };
    video_app_scene: { id: string };
    translations: {
      language: string;
      title: string;
    }[];
  }[];
}
export const createVideoTopics = async (): Promise<ShowroomTopics[] | null> => {
  if (!CMS_URL) {
    console.error('NO CMS_URL');
    return null;
  }
  if (!process.env.CMS_ACCESS_TOKEN) {
    console.error('NO CMS_ACCESS_TOKEN');
    return null;
  }
  const client = createDirectus(CMS_URL)
    .with(staticToken(process.env.CMS_ACCESS_TOKEN))
    .with(graphql());

  const query = `
      query fetchVideoTopicsConfig {
        video_app_topics {
          id
          slug
          parent_topic {
            id
          }
          video_app_scene {
            id
          }
          translations {
            title
            languages_code {
              code
            }
          }
        }
      }
    `;

  const result = await client.query<GraphqlResult>(query);

  const video_app_topics = result?.video_app_topics?.map(
    ({ translations, parent_topic, video_app_scene, slug, ...rest }) => {
      const trans: unknown = [];
      translations?.forEach((t) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { languages_code, ...rest } = t;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        trans.push({
          ...rest,
          language: languages_code.code.split('-')?.[0],
        });
      });
      return {
        ...rest,
        slug: slug || null,
        parent_topic: parent_topic?.id || null,
        video_app_scene: video_app_scene?.id || null,
        translations: trans,
      };
    },
  ) as ShowroomTopics[];

  const ret = parseVideoTopicsConfig(video_app_topics, null);

  return ret;

  /*  await fs.writeFile(
    path.resolve(__dirname, "json", fileName),
    JSON.stringify(ret),
    function (err) {
      if (err) {
        console.log("An error occured while writing JSON Object to File.");
        return console.log(err);
      }
    }
  ); */

  console.info(`🎉 Video Story Topics local JSON data created.`);
};
const parseVideoTopicsConfig = (
  nodes: ShowroomTopics[],
  parent: string | null,
): ShowroomTopics[] => {
  const ret = nodes
    .filter((node) => node.parent_topic === parent)
    .map((node_trans) => {
      return {
        ...node_trans,
        topics: parseVideoTopicsConfig(nodes, node_trans.id),
      };
    });

  return ret.length > 0 ? ret : [];
};
